import * as THREE from 'three';

export const isRef = (object: unknown): object is React.RefObject<THREE.Object3D> => {
  return !!object && typeof object === 'object' && 'current' in object;
};

export const isObject3D = (object: unknown): object is THREE.Object3D<THREE.Object3DEventMap> => {
  return !!object && typeof object === 'object' && 'isObject3D' in object;
};

export const isMesh = (object: THREE.Object3D): object is THREE.Mesh => {
  return (object as THREE.Mesh).isMesh;
};
